module.exports = __webpack_public_path__ + "img/enseignement-catholique.fe7146c.png";